import type { MutableRefObject } from "react";
import type { MatchRow } from "@shared/api";

export function applyIncomingMatches(
  rows: MatchRow[],
  opts: {
    knownIdsRef: MutableRefObject<Set<number> | null>;
    isMatchLogVisible: boolean;
    section: HTMLElement | null;
    onNewMatches: (ids: number[], showNotice: boolean) => void;
  },
) {
  const previousIds = opts.knownIdsRef.current;
  const nextIds = new Set(rows.map((row) => row.id));
  opts.knownIdsRef.current = nextIds;
  if (previousIds === null) return;

  const newIds = rows.filter((row) => !previousIds.has(row.id)).map((row) => row.id);
  if (newIds.length === 0) return;
  opts.onNewMatches(newIds, !opts.isMatchLogVisible || !isNearMatchLogTop(opts.section));
}

function isNearMatchLogTop(section: HTMLElement | null): boolean {
  if (!section) return window.scrollY < 240;
  const rect = section.getBoundingClientRect();
  return rect.top > -160 && rect.top < window.innerHeight * 0.55;
}
